import * as React from 'react';

import { mergeStyles } from '@fluentui/react/lib/Styling';

import { AppGalleryButton } from '@1js/acui-gallery';

import { AppFontStylesGalleryButtonProps } from './AppFontStylesGalleryButton.Props';

export const AppFontStylesGalleryButton: React.StatelessComponent<AppFontStylesGalleryButtonProps> = React.memo(
  (galleryButton: AppFontStylesGalleryButtonProps) => {
    const style = galleryButton.style;
    return (
      <AppGalleryButton
        {...galleryButton}
        title={undefined}
        label={galleryButton.styleDisplayName}
        ariaLabel={galleryButton.styleDisplayName}
        automationType={'AppFontStylesGalleryButton'}
        uniqueId={galleryButton.id}
        shouldTakeFocus={true}
      >
        <div className={mergeStyles(style && style.label)}>{galleryButton.styleDisplayName}</div>
      </AppGalleryButton>
    );
  }
);
